import data from "virtual:brand-config";
import { createBrandConfig } from "@hypexone/uicore";
import { getRootDomain } from "../view/pages/Payments/commonutils";
import type { WhitelabelEnvDTO } from "./whitelabelEnv";

/* Runtime side of the white-label config. The source of truth is still
 * whitelabelEnv.ts, but it is never bundled: uicore's brandConfigPlugin
 * (see vite.config.ts) encrypts it into `virtual:brand-config`, keyed by
 * hashed hostname. */

export type { WhitelabelEnvDTO };

export const brandConfig = createBrandConfig(data, {
  getRootDomain,
  // Same contract as the previous getEnvVariable for hosts with no config.
  unknownHost: "throw",
});

export function getEnvVariable(domain: string, variable: string) {
  return brandConfig.getEnvVariable(domain, variable);
}
